export default __webpack_public_path__ + "i18n/translations/translation-en.c321e547.json";